import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getAdditionalCharge,
  getParticularPage,
  getNext,
  getPrevious,
  createAdditionalCharge,
  updateAdditionalCharge,
  handleSearch,
  getAdditionalChargeById,
} from "./thunk";

const initialState = {
  additionalCharges: [],
  edit: false,
  additionalCharge: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingAdditionalCharge: false,
  loadingNext: false,
  showCreateModal: false,
};

export const additionalChargeSlice = createSlice({
  name: "additionalCharge",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllAdditionalCharge: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingAdditionalCharge = false;
      state.additionalCharge = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createAdditionalCharge.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createAdditionalCharge.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createAdditionalCharge.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateAdditionalCharge.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateAdditionalCharge.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateAdditionalCharge.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(getAdditionalChargeById.pending, (state) => {
      state.loadingUpdated = true;
      state.edit = true;
    });
    builder.addCase(getAdditionalChargeById.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.additionalCharge = action.payload.data;
    });
    builder.addCase(getAdditionalChargeById.rejected, (state) => {
      state.loadingUpdated = false;
      state.additionalCharge = null;
      state.edit = false;
    });
    builder.addMatcher(
      isAnyOf(
        getAdditionalCharge.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingAdditionalCharge = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getAdditionalCharge.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingAdditionalCharge = false;
        state.additionalCharges = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getAdditionalCharge.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingAdditionalCharge = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllAdditionalCharge } = additionalChargeSlice.actions;

export default additionalChargeSlice.reducer;
